(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Quick-add to cart (single variant products) */
  document.querySelectorAll('.fcni__quick-add-btn[data-product-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.productId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = btn.dataset.loadingText || 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = btn.dataset.addedText || 'Added!';
          /* Dispatch a custom event so themes can update their cart drawer/counter */
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.textContent = btn.dataset.originalText || 'Quick Add';
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = btn.dataset.errorText || 'Error – try again';
          btn.disabled = false;
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
